// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ka-0";